(function () {
  // Toggle debug logs in Console with:
  // window.__pp_debug_ajax_add_to_cart = true

  function debugLog() {
    try {
      if (window.__pp_debug_ajax_add_to_cart) {
        console.log.apply(console, arguments);
      }
    } catch (e) {}
  }

  function getClosestForm(el) {
    while (el && el !== document) {
      if (el.tagName && el.tagName.toLowerCase() === 'form') return el;
      el = el.parentNode;
    }
    return null;
  }

  function openDrawerOrPublish(addedItem) {
    const drawer =
      document.querySelector('cart-drawer') ||
      document.getElementById('CartDrawer') ||
      document.querySelector('.cart-drawer');

    if (drawer) {
      try {
        if (typeof drawer.open === 'function') {
          drawer.open();
          debugLog('Opened cart-drawer via element.open()');
          return;
        }
        drawer.classList.add('is-open', 'active');
        debugLog('Opened cart-drawer via class toggles');
        return;
      } catch (e) {
        debugLog('Error opening drawer element', e);
      }
    }

    if (typeof publish === 'function') {
      try {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'ajax-add',
          cartData: null,
          variantId: addedItem && addedItem.id,
        });
        debugLog('Published cart update via publish()');
        return;
      } catch (e) {
        debugLog('publish() threw', e);
      }
    }

    document.dispatchEvent(
      new CustomEvent('cart:added', {
        detail: addedItem,
      })
    );
    debugLog('Dispatched cart:added event');
  }

  function fetchDrawerDocument() {
    return new Promise(function (resolve, reject) {
      if (!window.routes || !routes.cart_url) {
        return reject(new Error('routes.cart_url missing'));
      }

      fetch(routes.cart_url + '?section_id=cart-drawer')
        .then(function (r) {
          if (!r.ok) throw r;
          return r.text();
        })
        .then(function (htmlText) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlText, 'text/html');
          resolve(doc);
        })
        .catch(function (err) {
          reject(err);
        });
    });
  }

  function ensureDrawerExists() {
    return new Promise(function (resolve, reject) {
      const currentDrawer =
        document.querySelector('cart-drawer') ||
        document.getElementById('CartDrawer') ||
        document.querySelector('.cart-drawer');

      if (currentDrawer) return resolve({ drawer: currentDrawer, serverDoc: null });

      fetchDrawerDocument()
        .then(function (doc) {
          const serverDrawer =
            doc.querySelector('cart-drawer') ||
            doc.querySelector('#CartDrawer') ||
            doc.querySelector('.cart-drawer');

          if (!serverDrawer) throw new Error('server did not return cart-drawer markup');

          document.body.insertAdjacentElement('beforeend', serverDrawer);

          setTimeout(function () {
            const drawer =
              document.querySelector('cart-drawer') ||
              document.getElementById('CartDrawer') ||
              document.querySelector('.cart-drawer');
            if (!drawer) return reject(new Error('drawer insertion failed'));
            resolve({ drawer: drawer, serverDoc: doc });
          }, 20);
        })
        .catch(function (err) {
          reject(err);
        });
    });
  }

  function updateExistingDrawerFromDoc(drawer, serverDoc) {
    try {
      const serverDrawerInner =
        serverDoc.querySelector('cart-drawer') ||
        serverDoc.querySelector('#CartDrawer') ||
        serverDoc.querySelector('.cart-drawer');

      if (!serverDrawerInner) {
        debugLog('No server drawer inner found to update from.');
        return;
      }

      const targetInner = drawer.querySelector('.drawer__inner');
      const serverInner = serverDrawerInner.querySelector('.drawer__inner');

      if (targetInner && serverInner) {
        targetInner.innerHTML = serverInner.innerHTML;
        debugLog('Updated existing drawer .drawer__inner content from server HTML');
        return;
      }

      const serverContent = serverDrawerInner.innerHTML;
      if (serverContent) {
        drawer.innerHTML = serverContent;
        debugLog('Replaced entire drawer innerHTML as fallback');
      }
    } catch (e) {
      debugLog('Error updating existing drawer from doc', e);
    }
  }

  function ensureOverlayAndPatchClose(drawer) {
    if (!drawer) return;

    let overlay = drawer.querySelector('#CartDrawer-Overlay') || drawer.querySelector('.cart-drawer__overlay');

    if (overlay) {
      try {
        const newOverlay = overlay.cloneNode(true);
        overlay.replaceWith(newOverlay);
        overlay = newOverlay;

        overlay.addEventListener('click', function (ev) {
          ev.preventDefault();
          try {
            if (typeof drawer.close === 'function') drawer.close();
          } catch (e) {
            console.warn('drawer.close() failed', e);
          }
        });
      } catch (e) {
        debugLog('Failed to rebind overlay click', e);
      }
    }

    try {
      // allow re-patching: do not permanently block re-run. Use flag to avoid double wrapping
      if (drawer._ppClosePatched) return;
      drawer._ppClosePatched = true;

      const originalClose = drawer.close && drawer.close.bind(drawer);

      drawer.close = function patchedClose(...args) {
        try {
          if (typeof originalClose === 'function') originalClose(...args);
        } catch (e) {
          console.warn('original drawer.close threw', e);
        }

        document.querySelectorAll('#CartDrawer-Overlay, .cart-drawer__overlay').forEach((ov) => {
          const parentDrawer = ov.closest('cart-drawer') || ov.closest('#CartDrawer') || ov.closest('.cart-drawer');
          if (!parentDrawer || parentDrawer !== drawer) {
            ov.remove();
          }
        });

        const currentOverlay = drawer.querySelector('#CartDrawer-Overlay') || drawer.querySelector('.cart-drawer__overlay');
        if (currentOverlay) {
          currentOverlay.classList.remove('is-open', 'active');
          currentOverlay.style.display = 'none';
          setTimeout(() => {
            currentOverlay.style.display = '';
          }, 300);
        }

        document.body.classList.remove('overflow-hidden');

        // Allow re-patching on next open by clearing flag after a short delay
        setTimeout(function () {
          try {
            drawer._ppClosePatched = false;
            debugLog('Reset _ppClosePatched flag to allow re-patching');
          } catch (e) {}
        }, 50);
      };
    } catch (e) {
      console.warn('Failed to patch drawer.close for overlay cleanup', e);
    }
  }

  document.addEventListener('submit', function (evt) {
    try {
      const form = getClosestForm(evt.target);
      if (!form) return;

      const matches =
        form.matches &&
        (form.matches('form[data-type="add-to-cart-form"]') ||
          form.matches('form[action^="/cart/add"]') ||
          form.matches('.ajax-cart') ||
          form.matches('form[data-ajax="true"]'));

      if (!matches) return;

      if (form.querySelector('[type="submit"][disabled]')) {
        debugLog('Form submit allowed: submit disabled');
        return;
      }

      if (form.dataset.ajaxHandledByPp) {
        debugLog('Form already handled by this script');
        return;
      }

      evt.preventDefault();
      evt.stopImmediatePropagation?.();

      form.dataset.ajaxHandledByPp = 'true';
      debugLog('Intercepted add-to-cart submit for', form);

      // Disable submit buttons to avoid duplicate clicks while request in-flight
      const submitButtons = Array.from(form.querySelectorAll('[type="submit"], button[name="add"]')).filter(Boolean);
      submitButtons.forEach((btn) => (btn.disabled = true));

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      })
        .then(function (res) {
          if (!res.ok) {
            debugLog('Add to cart response not ok', res.status);
            throw res;
          }
          return res.json();
        })
        .then(function (addedItem) {
          debugLog('AJAX add-to-cart succeeded', addedItem);

          ensureDrawerExists()
            .then(function (result) {
              const drawer = result.drawer;
              const serverDoc = result.serverDoc; // may be null if drawer already existed

              if (serverDoc === null && drawer) {
                fetchDrawerDocument()
                  .then(function (doc) {
                    updateExistingDrawerFromDoc(drawer, doc);
                  })
                  .catch(function (err) {
                    debugLog('Failed to fetch server doc for update', err);
                  });
              }

              try {
                ensureOverlayAndPatchClose(drawer);
              } catch (e) {
                debugLog('ensureOverlayAndPatchClose failed', e);
              }

              try {
                if (drawer && typeof drawer.open === 'function') {
                  drawer.open();
                  debugLog('Opened drawer via instance.open()');
                } else if (drawer) {
                  drawer.classList.add('is-open', 'active');
                  debugLog('Opened drawer by toggling classes');
                } else {
                  openDrawerOrPublish(addedItem);
                }
              } catch (e) {
                debugLog('Error opening drawer after ensure', e);
                openDrawerOrPublish(addedItem);
              }
            })
            .catch(function (err) {
              debugLog('ensureDrawerExists failed', err);
              openDrawerOrPublish(addedItem);
            })
            .finally(function () {
              // Re-enable submit buttons and clear handlers marker so the form can be used again
              submitButtons.forEach((btn) => (btn.disabled = false));
              try {
                delete form.dataset.ajaxHandledByPp;
              } catch (e) {}
            });
        })
        .catch(function (err) {
          debugLog('AJAX add-to-cart failed, falling back to native submit', err);
          try {
            delete form.dataset.ajaxHandledByPp;
            submitButtons.forEach((btn) => (btn.disabled = false));
            form.submit();
          } catch (e) {
            debugLog('Native submit fallback failed', e);
            window.location.href = '/cart';
          }
        });
    } catch (e) {
      console.error('AJAX add-to-cart delegation error', e);
    }
  });
})();